import React from "react";

export interface TextWithNewlinesProps {
  text: string;
}
export const TextWithNewlines: React.FC<TextWithNewlinesProps> = ({ text }) => {
  if (!text) return null;

  return (
    <>
      {text.split(/\\n|\n/).map((line, index, array) => (
        <React.Fragment key={`line-${line}-${index}`}>
          {line}
          {index < array.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  );
};

export default TextWithNewlines;
